module.exports = __webpack_public_path__ + "static/media/JOIP_logomark_color.bd198975.png";